module.exports = __webpack_public_path__ + "img/badgeValidatedLine.1be2b0d3.svg";